import { render, staticRenderFns } from "./receipt-info-header.vue?vue&type=template&id=26953732&scoped=true"
import script from "./receipt-info-header.vue?vue&type=script&lang=ts"
export * from "./receipt-info-header.vue?vue&type=script&lang=ts"
import style0 from "./receipt-info-header.vue?vue&type=style&index=0&id=26953732&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26953732",
  null
  
)

export default component.exports